// Production
/*
export default {
  apiKey: "AIzaSyCgoPVxdPA9iVTvaEh9amhmrQxRdPfn7os",
  authDomain: "ascension-d81f3.firebaseapp.com",
  databaseURL: "https://ascension-d81f3.firebaseio.com",
  projectId: "ascension-d81f3",
  storageBucket: "ascension-d81f3.appspot.com",
  messagingSenderId: "294042344551"
}
*/

//Development

export default {
  apiKey: "AIzaSyAk3PVn8M_uEJS3GKWffHvzQ3TgiZ3YS1E",
  authDomain: "ascension-firebase-test.firebaseapp.com",
  databaseURL: "https://ascension-firebase-test.firebaseio.com",
  projectId: "ascension-firebase-test",
  storageBucket: "ascension-firebase-test.appspot.com",
  messagingSenderId: "78873004215"
}

/*
Comment the code above for the necessary api

Run: npm run build

For production, run the following: firebase use production
For development, run the following: firebase use development
------------------------------------------------------------
Run: firebase deploy
*/



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js